// src/pages/Team.jsx
import Layout from "../layouts/Layout";

import Breadcrumb from "../components/Breadcrumb";
import TeamSection from "../components/Team/TeamSection";
import TestimonialSection from "../components/About/TestimonialSection";

const Team = () => (
  <Layout>
    <Breadcrumb
      title="Đội ngũ Design24"
      parent={{ name: "Trang chủ", path: "/" }}
    />

    {/* Team Section */}
    <TeamSection />

    {/* Optionally reuse */}
    <TestimonialSection />
  </Layout>
);

export default Team;
